/**
=========================================================
* Material Dashboard 2 PRO React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
 */

// react-router-dom components
import {Link, useParams} from "react-router-dom";

// @mui material components

// Material Dashboard 2 PRO React components
// Images
import bgImage from "../splash.jpg";
import React, {useEffect, useState} from "react";
import SplashScreen from "../Layout/SplashScreen";
import {Alert, Box, Button, Paper, TextField, Typography} from "@mui/material";


export default function NewPasswordPage() {
  const params = useParams();
  const [password, setPassword] = useState("");
  const [passwordAgain, setPasswordAgain] = useState("");
  const [flashMessage, setFlashMessage] = useState("");
  const [flash, setFlash] = useState("");

  useEffect(() => {
    if (flashMessage !== '') {
      if(flashMessage === 'success') {
        setFlash(<Alert severity="success">Zresetowano hasło. <Link to={'/login'}>Zaloguj się</Link></Alert>);
      } else {
        setFlash(<Alert severity={'error'}>Nieaktywny token resetujący.</Alert>);
      }
    } else {
      setFlash('');
    }
  }, [flashMessage]);
  const newPasswordUser = (e) => {
    e.preventDefault();
    const sentData = {password: password};
    if (password !== passwordAgain) {
      setFlash(<Alert severity={'warning'}>Podane hasła się nie zgadzają.</Alert>);
      return null;
    }
    fetch(`/api/user/reset/${params.token}`, {
      cache: "no-cache",
      method: "post",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(sentData),
    })
        .then((response) => {
          if (!response.ok) {
            throw Error(response.statusText);
          }
          response.json().then(function (data) {
            setFlashMessage(data);
          });
        })
        .catch((error) => {
          console.log(error.message);
        });
  };

  return (
      <SplashScreen background={bgImage} title={'Wakacyjne Zajęcia'}>
       <Paper elevation={24} sx={{
        width: '500px',
        maxWidth: '80vw',
        overflow: 'visible',
        overflowWrap: 'break-word',
        backgroundClip: 'border-box',
        paddingTop: '1px'
       }}>
        <Box
            mx={2}
            mt={-3}
            p={2}
            mb={1}
            textAlign="center"
            sx={{
             background: 'linear-gradient(195deg, rgb(66, 66, 74), rgb(25, 25, 25))',
             boxShadow: 'rgba(0, 0, 0, 0.14) 0rem 0.25rem 1.25rem 0rem, rgba(64, 64, 64, 0.4) 0rem 0.4375rem 0.625rem -0.3125rem',
             margin: '-24px 16px 8px',
             padding: '16px',
             borderRadius: '0.375rem',
             opacity: 1
            }}>
          <Typography variant="h5" fontWeight="light" color="white">
            Ustaw nowe hasło
          </Typography>
        </Box>
        {flash}
        <Box pt={4} pb={3} px={3}>
          <Box component="form" role="form" onSubmit={newPasswordUser}>
            <Box mb={2}>
              <TextField autoFocus type="password" required label="Hasło" variant="standard" fullWidth autoComplete={'new-password'}
                       value={password} onChange={(e) => setPassword(e.target.value)}/>
            </Box>
            <Box mb={2}>
              <TextField type="password" required label="Powtórz Hasło" variant="standard" fullWidth autoComplete={'off'}
                       value={passwordAgain} onChange={(e) => setPasswordAgain(e.target.value)}/>
            </Box>
            <Box mt={4} mb={1}>
              <Button variant="contained" color="primary" fullWidth type={'submit'}>
                Ustaw hasło
              </Button>
            </Box>
          </Box>
        </Box>
       </Paper>
    </SplashScreen>
  );
}
